import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LevelBadgeStoreService } from './level-badge-store.service';
import { LevelBadgeComponent } from './level-badge.component';
import { TrialBadgeComponent } from './trial-badge.component';

const MatModules = [MatIconModule, MatMenuModule, MatTooltipModule];

@NgModule({
  imports: [CommonModule, MatModules, TranslateModule],
  declarations: [LevelBadgeComponent, TrialBadgeComponent],
  exports: [LevelBadgeComponent, TrialBadgeComponent],
  providers: [LevelBadgeStoreService],
})
export class LevelBadgeModule {}
